export const getFileBadge = (fileType = '') => {
  if (fileType.startsWith('image/')) return 'IMAG';
  if (fileType === 'application/pdf') return 'PDF';
  if (fileType.includes('word')) return 'DOC';
  if (fileType.includes('sheet') || fileType.includes('excel')) return 'XLS';
  if (fileType.startsWith('video/')) return 'VID';
  if (fileType.startsWith('audio/')) return 'AUD';
  return 'FILE';
};

export const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return '';

  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const getAttachmentId = (attachment) => attachment?.ptsAttachmentID ?? attachment?.id;
